import { render } from "./NoneCard.vue?vue&type=template&id=0aee3ae8"
import script from "./NoneCard.vue?vue&type=script&lang=js"
export * from "./NoneCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__